import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { ScrollArea } from "../ui/scroll-area";
import { Button } from "../ui/button";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { AlertCircle, Check, ChevronLeft, ChevronRight, Save } from "lucide-react";
import { useTestRuleAI } from "@/hooks/useLocalStorage";

interface TestRuleStepProps {
    finalRule: string;
    onBack: () => void;
    onNext: () => void;
    testResult: { success?: boolean; message: string; details: string };
    setTestResult: (value: { success: boolean; message: string; details: string }) => void;
    variablePairs: object
}

export const TestRuleStep = ({ finalRule, onBack, onNext, testResult, setTestResult, variablePairs }: TestRuleStepProps) => {
    const [isTesting, setIsTesting] = useState(false);
    const testRuleData = useTestRuleAI()

    console.log(finalRule, "finalRule")
    console.log(variablePairs, "variablePairs")

    const buildParamsPayload = (variablePairs: object) => {
        const Pairs = Object.values(variablePairs);
        const params: any = {};

        Pairs.forEach(pair => {
            const type = pair.mappedDataType;
            const attr = pair.mappedAttribute;

            if (!type || !attr) return;

            if (!params[type]) {
                params[type] = {};
            }

            const randomValue = Math.floor(Math.random() * 100) + 1;
            params[type][attr] = randomValue;
        });

        return params;
    };


    const handleTest = async () => {
        setIsTesting(true);

        const test_data = await buildParamsPayload(variablePairs);

        const payload = {
            prompt: finalRule,
            test_data
        };

        try {
            const res: any = await testRuleData.mutateAsync(payload)
            if (res) {
                setTestResult({
                    success: true,
                    message: "Rule validated successfully",
                    details: 'All conditions evaluated correctly'
                });
            } else {
                setTestResult({
                    success: false,
                    message: "Rule validation failed",
                    details: 'All conditions evaluated correctly'
                });
            }

        } catch (err) {
            setTestResult({
                success: false,
                message: "Rule validation failed, Please create a valid Rule",
                details: 'All conditions evaluated correctly'
            });
        }

        setIsTesting(false);
    };

    return (
        <div className="space-y-6">
            <Card>
                <CardHeader>
                    <CardTitle>Final Rule</CardTitle>
                    <CardDescription>Test your complete rule with all variables mapped</CardDescription>
                </CardHeader>
                <CardContent>
                    <ScrollArea className="h-[220px] w-full rounded-md border bg-slate-50 p-4">
                        <code className="text-sm font-mono whitespace-pre-wrap">{finalRule}</code>
                    </ScrollArea>
                </CardContent>
            </Card>

            <Card>
                <CardHeader>
                    <CardTitle>Test Final Rule</CardTitle>
                    <CardDescription>Validate your rule before saving</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <Button
                        onClick={handleTest}
                        disabled={isTesting}
                        className=""
                        variant="outline"
                    >
                        {isTesting ? 'Testing...' : 'Run Validation Test'}
                    </Button>

                    {testResult.message && (
                        <Alert variant={testResult.success ? "default" : "destructive"}>
                            {testResult.success ? (
                                <Check className="h-4 w-4" />
                            ) : (
                                <AlertCircle className="h-4 w-4" />
                            )}
                            <AlertTitle>{testResult?.success === true ? 'Success' : 'Failed'}</AlertTitle>
                            <AlertDescription>{testResult.message}</AlertDescription>
                        </Alert>
                    )}
                </CardContent>
            </Card>

            <div className="flex justify-between gap-4">
                <Button variant="outline" onClick={onBack} className="gap-2">
                    <ChevronLeft className="h-4 w-4" />
                    Back
                </Button>

                <Button
                    onClick={onNext}
                    disabled={!testResult || !testResult.success}
                    className="gap-2"
                >
                    Next
                    <ChevronRight className="h-4 w-4" />
                </Button>
            </div>
        </div>
    );
};